<app-navbar title="Promocje">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-promotions-list-filters
	userFilters="promotions"
	[yesno]="parameters.yesno"
	[products]="parameters.products"
	(selected)="filtersSelected($event)"
></app-promotions-list-filters>

<app-dynamic-table
	module="promotions"
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
